import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { MissMagnolia, Sentinel } from '@styles/global/fonts'
import { colors } from '@styles/global/colors'

interface IPrimaryLockupProps {
  color?: string
}

export const PrimaryLockup = styled.div<IPrimaryLockupProps>`
    text-align: center;
    color: ${props => props.color ? props.color : props.theme.headlineColor};
    padding: 0 20px;
    max-width: 810px;
    width: 100%;
    margin: 30px auto 30px;
    
    h2{
      font-size: 28px;
      line-height: 42px;
      margin: 20px 0;
      color: #313a54;
      font-weight: 600;
    }
    
    h3{
      margin:0;
      font-size: 24px;
      line-height: 32px;
      font-weight: 500;
    }
    
    @media ${device.tablet}{
      h2{
        font-size: 42px;
        line-height: 56px;
      }
    }
`

interface IMMH2Props {
  textColor?: string
  headlineColor?: string
}

export const MMH2 = styled.div<IMMH2Props>`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
  
  h2{
    ${MissMagnolia};
    text-align: left;
    font-size: 40px;
    color: ${props => props.textColor ? props.textColor : colors.text};
    text-transform: uppercase;
    line-height: 48px;
    margin-bottom: 10px;
  }
  h3{
    ${MissMagnolia};
    text-align: left;
    font-size: 32px;
    color: ${props => 
            props.headlineColor 
                    ? props.headlineColor 
                    : props.textColor 
                      ? props.textColor 
                      : colors.text};
    text-transform: uppercase;
    line-height: 38px;
    margin-bottom: 10px;
  }
  p{
    color: ${props => props.textColor ? props.textColor : colors.text};
    font-size: 18px;
    font-weight: 500;
  }
  
  @media ${device.tablet}{
    h2{
      font-size: 64px;
      line-height: 72px;
    }
    h3{
      font-size: 44px;
      line-height: 60px;
    }
  }
`

export const SentinelHeadline1 = styled.h2`
    margin-bottom: .5em;
    ${Sentinel.semiboldItalic};
    font-size: 38px;
    font-weight: 500;
    line-height: 1.2;
    color: ${props => props.theme.headlineColor};
    
    @media ${device.tablet} {
      font-size: 44px;
      max-width: none;
    }
    
    @media ${device.laptop} {
      font-size: 48px;
    }
    @media ${device.laptopL} {
      font-size: 60px;
    }
  }
`
